import { render } from "./AcPreloader.vue?vue&type=template&id=79b45e83&scoped=true&ts=true"
import script from "./AcPreloader.vue?vue&type=script&lang=ts"
export * from "./AcPreloader.vue?vue&type=script&lang=ts"

import "./AcPreloader.vue?vue&type=style&index=0&id=79b45e83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b45e83"]])

export default __exports__